import React, { useContext } from 'react';
import { Form } from 'antd';
import { useAppSelector } from '../../../../utilities/hooks';
import { accessCheck, SmxPermissionContext } from '@sitemax/smx-permission';
import { FieldScheduleItem, ScheduleItemType } from '@sitemax/smx-components';
import { NewItemType } from '../../../../types';

const FieldScheduleItemForAddItem = () => {
    const globalFilterProject = useAppSelector((state) => state.app.globalFilterProject);

    const { userId, permissionListScore } = useContext(SmxPermissionContext);

    const form = Form.useFormInstance<NewItemType>();

    const values = Form.useWatch([], form);

    const filterFlexibleProject = globalFilterProject?.length
        ? `{"or":[{"project_d":"${globalFilterProject.join('|')}"}]}`
        : '';

    const filterFlexibleScheduleItem = `[{"or":[{"role_item":"workItem", "phase_id":"${values?.['phaseId']?.toString()}"}]}${filterFlexibleProject ? ', ' + filterFlexibleProject : ''}]`;

    return (
        <FieldScheduleItem
            name={'parentId'}
            // localFilters={{
            //     role_item: 'workItem',
            //     phase_id: values?.['phaseId']?.toString(),
            // }}
            filterFlexible={filterFlexibleScheduleItem}
            disabled={!values?.['phaseId']}
            checkAccessPermission={(item: ScheduleItemType) => {
                const isOwner = item?.owner_item_id === userId;
                const isAssignee = item?.assignee?.includes(userId);
                return accessCheck(
                    permissionListScore,
                    [
                        'work-item.all.create',
                        'work-item.all.edit',
                        'work-item.all.manage',
                        'work-item.owner.create',
                        'work-item.owner.edit',
                        'work-item.owner.manage',
                        'work-item.assignee.create',
                        'work-item.assignee.edit',
                        'work-item.assignee.manage',
                    ],
                    isOwner,
                    isAssignee,
                );
            }}
        />
    );
};

export default FieldScheduleItemForAddItem;
